import React from "react";

function PaymentOverlay() {
	return (
		<div className="c-loader__full-overlay js-payment-overlay" role="dialog" aria-labelledby="payment-overlay" aria-modal="true">
			<div className="c-loader__full-overlay-content">
				<h2 className="c-loader__full-overlay-text c-loader__full-overlay-text--title h1" id="payment-overlay">Processing your payment.</h2>
				<div className="c-loader c-loader--large c-loader__full-overlay-loader"><span className="u-visuallyhidden">Loading...</span></div>
				<p className="c-loader__full-overlay-text c-loader__full-overlay-text--body">Please do not close the browser window, refresh the page, or use the back button.</p>
			</div>
		</div>
	);
}

export default PaymentOverlay;
